import { Card, CardGroup } from '@ps/sports-ui-component-library';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { MarketTemplate } from '@swf/sports/components';
import DefaultEventCard from '@swf/sports/components/EventCard/components/DefaultEventCard/DefaultEventCard';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';
import { isMarketTemplateView } from '@swf/sports/types/templates';
import { isCompoundMarketTemplate } from '@swf/sports/utils/isCompoundMarketTemplate';

import AntePostEndedMessage from './components/AntePostEndedMessage/AntePostEndedMessage';
import { sportsAntePostMarketWidgetModel, useSportsAntePostMarketWidget } from './model';

const SportsAntePostMarketWidget: WidgetFC = () => {
  const { widgetSelect, widgetDispatch } = useSportsAntePostMarketWidget();
  const market = useSelector(widgetSelect.firstMarket);
  const event = useSelector(widgetSelect.firstEvent);
  const templates = useSelector(widgetSelect.templates);
  const marketIds = useSelector(widgetSelect.marketIds);
  const hasAntePostMarketClosed = useSelector(widgetSelect.hasAntePostMarketClosed);

  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  if (!market) {
    return null;
  }

  const { marketTime, marketName } = market;

  return (
    <>
      <DefaultEventCard
        title={event.eventName}
        eventTime={marketTime}
        subTitle={marketName}
        eventTypeId={event.eventTypeId}
      />
      {hasAntePostMarketClosed ? (
        <AntePostEndedMessage />
      ) : (
        <CardGroup padded flushOnMobile>
          {templates.filter(isMarketTemplateView).map(({ template }) => {
            const activeMarketId = isCompoundMarketTemplate(template)
              ? template.marketIds[0]
              : template.marketId;

            return (
              <Card key={activeMarketId}>
                <MarketTemplate {...template} />
              </Card>
            );
          })}
        </CardGroup>
      )}
    </>
  );
};

SportsAntePostMarketWidget.model = sportsAntePostMarketWidgetModel;

export default withWidgetTestId(SportsAntePostMarketWidget, 'sports-ante-post-market');
